export default values => {
  const errors = {};

  if (!values.label) {
    errors.label = 'Required';
  } else if (values.label.length < 2) {
    errors.label = 'Must be 2 characters or more';
  }

  if (!values.warehouse) {
    errors.warehouse = 'Required';
  }

  // Devices group validation

  const devicesGroup = [];
  if (values.devicesGroup?.length) {
    values.devicesGroup.forEach((dg, index) => {
      const fieldErrors = {};

      if (dg.groupName && dg.groupName.length < 2) {
        fieldErrors.groupName = { _error: 'Min 2 characters' };
      } else if (dg.groupName && dg.groupName.length > 255) {
        fieldErrors.groupName = { _error: 'Max 255 characters' };
      }

      if (!dg.devices?.length) {
        fieldErrors.devices = { _error: 'Required' };
      }

      if (Object.keys(fieldErrors).length) {
        devicesGroup[index] = fieldErrors;
      }
    });
  }

  if (devicesGroup.some(Boolean)) {
    errors.devicesGroup = devicesGroup;
  }

  return errors;
};
